import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import localStorageNames from '@data/localStorageNames';

export const useStoreSiccMember = create(
  persist(
    (set) => ({
      siccMember: null,
      updateSiccMember: (newMember) => {
        set({ siccMember: newMember });
      },
      clearSiccMember: () => set({ siccMember: null }),
    }),
    {
      name: localStorageNames.SICC_MEMBER,
    },
  ),
);
